// The redesign's button (Figma "Button": Style × Size). Primary is the one
// "act here" action on a view; Danger is for the destructive confirm only.
import * as React from 'react';
import { cn } from '../../lib/utils';

export const FOCUS = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-default focus-visible:ring-offset-2 focus-visible:ring-offset-bg-canvas';

const KIND = {
  primary: 'bg-accent-default text-accent-on hover:bg-accent-hover',
  secondary: 'border border-border-default bg-bg-surface text-text-primary hover:bg-bg-raised',
  text: 'text-accent-default hover:bg-accent-tint',
  // Figma's Danger label is bg/canvas: dark on coral in both schemes.
  danger: 'bg-status-danger text-bg-canvas hover:opacity-90',
};
const SIZE = {
  default: 'h-[52px] px-6 type-button',
  small: 'h-10 px-4 type-button-small',
};

export const Button = React.forwardRef(function Button(
  { kind = 'primary', size = 'default', loading = false, block = false, icon = null, disabled, className, children, type = 'button', ...props },
  ref,
) {
  const off = disabled || loading;
  return (
    <button ref={ref} type={type} disabled={off} aria-busy={loading || undefined}
      className={cn('inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full transition-colors',
        'disabled:pointer-events-none disabled:opacity-50', FOCUS, KIND[kind], SIZE[size], block && 'w-full', className)}
      {...props}>
      {loading ? <span aria-hidden="true" className="h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" /> : icon}
      <span className={cn(loading && 'sr-only')}>{children}</span>
    </button>
  );
});
